import Clarity from '@microsoft/clarity'

const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID
const CONSENT_KEY = "encircled_cookie_consent"

export function initClarity() {
  if (!projectId) return
  Clarity.init(projectId)
}

export function getStoredConsent() {
  return localStorage.getItem(CONSENT_KEY)
}

export function setClarityConsent(granted) {
  localStorage.setItem(CONSENT_KEY, granted ? "granted" : "denied")
  if (!projectId) return
  Clarity.consentV2({ ad_Storage: 'denied', analytics_Storage: granted ? 'granted' : 'denied' })
}

// customId is hashed by Clarity client-side before it ever reaches their servers.
// Pass our own DB user id so sessions can be looked up later via Clarity's
// "Custom ID" search filter (which hashes the search input the same way to match).
export function identifyClarityUser(user) {
  if (!projectId || !user || getStoredConsent() !== "granted") return
  Clarity.identify(String(user.id))
}
